
export default {
  props: {
    groups: { type: Array, default: () => [] },
    halls: { type: Array, default: () => [] },
  },

  watch: {
    "$route.query.group" () {
      this.$router.push({
        query: {
          ...this.$route.query,
          hall: this.halls[0]?.alias || undefined,
        },
      })
    },
  },
}
